import { isNumber } from "@zickko/shared";
import { Result } from "nutso";
import React, { useState } from "react";

/**
 * Note:
 * This component should be used when dealing with a data model who's type is both number and undefined, otherwise, use <NumberInput/>
 *  e.g. type ItemSummary = { extraChargeForComments?: number; }
 */

export type NumberOrUndefinedInputProps = {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  validation: Result<number>;
  disabled?: boolean;
  dataCy?: string;
  step?: string;
  customRef?: React.RefObject<HTMLInputElement>;
  inputMode?: "numeric" | "decimal";
};

export const NumberOrUndefinedInput = (props: NumberOrUndefinedInputProps) => {
  const initialValue = !isNumber(props.value) ? "" : props.value;
  const [value, setValue] = useState(initialValue);

  return (
    <input
      type="number"
      step={props.step}
      value={value}
      onChange={(e) => {
        // always bind to the local observable
        setValue(e.target.value);

        // if value is number then, call onChange
        if (isNumber(e.target.valueAsNumber)) {
          props.onChange(e.target.valueAsNumber);
          return;
        }
        // if value is empty string, then pass 0
        if (e.target.value === "") {
          props.onChange(undefined);
          return;
        }
      }}
      className={props.validation.isValid ? "valid" : "invalid"}
      disabled={props.disabled}
      data-cy={props.dataCy}
      ref={props.customRef}
      inputMode={props.inputMode ?? "numeric"}
    />
  );
};
